
const digest = 'bbd2550a6c542f262648815908de9905c185e903285e42a8927546289fe17c34';
const classes = {"wrapper":"_wrapper_f0gs5_1","text":"_text_f0gs5_7"};
const css = `._wrapper_f0gs5_1 {
  padding: 24px;
  height: 100%;
  border-right: 1px solid #eaedf3;
  border-top: 1px solid #eaedf3;
}
._wrapper_f0gs5_1 ._text_f0gs5_7 {
  font-size: 14px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  